import React from 'react';
import { Box, Alert, CircularProgress, Paper } from '@mui/material';
import useApi from '../hooks/useApi';
import StatusChangesSummary from './StatusChangesSummary';
import StatusChangesTable from './StatusChangesTable';

const StatusChangesTab = ({
  onNavigateToDealer,
  onOpenDetail,
  userEmail,
  isMaximized,
  onToggleMaximize,
  enableInternalScroll = false,
}) => {
  const { useStatusChanges } = useApi();
  const { data, isLoading, error } = useStatusChanges();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 3 }}>
        <StatusChangesSummary />
      </Paper>

      <Paper variant="outlined" sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 3 }}>
        {isLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        )}
        {error && <Alert severity="error">{error?.message || 'Failed to load status changes.'}</Alert>}
        {!isLoading && !error && (
          Array.isArray(data) && data.length > 0 ? (
            <StatusChangesTable
              rows={data}
              isMaximized={isMaximized}
              onToggleMaximize={onToggleMaximize}
              onNavigateToDealer={onNavigateToDealer}
              userEmail={userEmail}
              onOpenDetail={onOpenDetail}
              enableInternalScroll={enableInternalScroll}
            />
          ) : (
            <Alert severity="info">No selection status changes found.</Alert>
          )
        )}
      </Paper>
    </Box>
  );
};

export default StatusChangesTab;

